import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {
    IEducationalBlocksPayload,
    IEducationalBlockTypesPayload,

    IInitialStateEducationalBlocks
} from "../types";
import {GetDeleteEducationalBlocks, GetEducationalBlocks, GetEducationalBlockTypes} from "./thunk";


import {ITranslation} from "../../../../types";


const initialState: IInitialStateEducationalBlocks = {
    educationalBlocksData: [],

    isLoadingEducationalBlocks: false,
    isViewEducationalBlocksRestore: false,
    educationalBlockTypes: [],
    filteredBlockTypes: [],
    educationalBlocksRestoreData: []
}


const educationalBlocksSlice = createSlice({
    name: "educationalBlock",
    initialState,
    reducers: {

        setEducationalBlockData: (state, action: PayloadAction<{
            data: IEducationalBlocksPayload[],

        }>) => {
            const {data} = action.payload;
            state.educationalBlocksData = data


        },
        setEducationalBlockTypes: (state, action: PayloadAction<{
            data: IEducationalBlockTypesPayload[],
            defaultLanguage: string
        }>) => {
            const {data, defaultLanguage} = action.payload
            state.educationalBlockTypes = data
            state.filteredBlockTypes = data.flatMap(
                (data: any) =>
                    data.translations
                        .filter((elem: ITranslation) => elem.slug === defaultLanguage && elem.name)
                        .map((elem: ITranslation) => ({
                            id: data.id,
                            name: elem.name as string,


                        }))
            );
        },
        updateEducationalBlocks: (
            state,
            action: PayloadAction<IEducationalBlocksPayload>
        ) => {
            const updateData = action.payload;

            state.educationalBlocksData = state.educationalBlocksData.map(
                (elem) => {
                    if (elem.id === updateData.id) {
                        return {
                            ...elem,
                            ...updateData,
                        };
                    }
                    return elem;
                }
            );
        },
        updateEducationalSettings: (
            state,
            action
        ) => {
            const updateData = action.payload;
            state.educationalBlockTypes = state.educationalBlockTypes.map(
                (elem) => {
                    if (elem.id === updateData.id) {
                        return {
                            ...elem,
                            ...updateData,
                        };
                    }
                    return elem;
                }
            );
        },
        deletedEducationalBlocks: (state, action: PayloadAction<number>) => {
            state.educationalBlocksData = state.educationalBlocksData.filter((elem) => elem.id !== action.payload);
        },
        setEducationalBlocksRestoreData: (state, action) => {
            state.educationalBlocksRestoreData = action.payload;
        },
        setIsViewRestoreEducationalBlocksRestore: (state) => {
            state.isViewEducationalBlocksRestore = !state.isViewEducationalBlocksRestore;
        },
        deletedRestoreEducationalBlocks: (state, action) => {
            state.educationalBlocksRestoreData = state.educationalBlocksRestoreData.filter((elem) => elem.id !== action.payload);
        },

    },
    extraReducers: (builder) => {
        builder
            .addCase(GetEducationalBlocks.pending, (state) => {
                state.isLoadingEducationalBlocks = true;
            })
            .addCase(
                GetEducationalBlocks.fulfilled,
                (state) => {
                    state.isLoadingEducationalBlocks = false;

                }
            )
            .addCase(GetEducationalBlocks.rejected, (state) => {
                state.isLoadingEducationalBlocks = false;
            })
            .addCase(GetEducationalBlockTypes.pending, (state) => {
                state.isLoadingEducationalBlocks = true;
            })
            .addCase(
                GetEducationalBlockTypes.fulfilled,
                (state) => {
                    state.isLoadingEducationalBlocks = false;

                }
            )
            .addCase(GetEducationalBlockTypes.rejected, (state) => {
                state.isLoadingEducationalBlocks = false;
            })
            .addCase(GetDeleteEducationalBlocks.pending, (state) => {
                state.isLoadingEducationalBlocks = true;
            })
            .addCase(GetDeleteEducationalBlocks.fulfilled, (state) => {
                    state.isLoadingEducationalBlocks = false;

                }
            )
            .addCase(GetDeleteEducationalBlocks.rejected, (state) => {
                state.isLoadingEducationalBlocks = false;
            })
    }
})

export const {
    setEducationalBlockData,
    setEducationalBlockTypes,
    updateEducationalBlocks,
    deletedEducationalBlocks,
    updateEducationalSettings,
    setEducationalBlocksRestoreData,
    setIsViewRestoreEducationalBlocksRestore,
    deletedRestoreEducationalBlocks
} = educationalBlocksSlice.actions;

export default educationalBlocksSlice